import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { showQuizPickerModal } from '@/shared/features/quiz-picker';

/**
 * `다음 퀴즈 이어풀기` 에 연결할 퀴즈를 고른다.
 *
 * 화면은 폴더의 `퀴즈 추가` 와 같은 `showQuizPickerModal` 이다. 이 훅은 그 모달을 빌드 폼이
 * 기대하는 모양(고른 id 를 await 로 받는다)으로 감싸는 얇은 어댑터다.
 *
 * `rootOnly: false` — 다음 퀴즈는 폴더 안에 있든 밖에 있든 이어 붙일 수 있다.
 *
 * **잠긴 퀴즈는 고를 수 없다**(`lockedSelectLabel`). 이 설정 자체가 `CONTINUE_NEXT_QUIZSET`
 * (PRO 전용) 게이트 뒤라 PRO 사용자에게 잠긴 퀴즈는 원래 없지만, `변경` 버튼 경로에는 그
 * 게이트가 없어(`ToggleNextQuizsetField` 의 `onChangeButtonClick`) **플랜이 만료된 뒤에는**
 * 잠긴 퀴즈가 목록에 보인다. 골라 봐야 재생에서 걸러지므로 그 자리에서 막는다.
 */
export const useOpenNextQuizsetSelectModal = () => {
  const {
    t
  } = useTranslation(['build']);
  return async ({
    excludeQuizsetIds
  }: {
    excludeQuizsetIds: string[];
  }) => {
    let selectedQuizsetId: string | undefined;
    await showQuizPickerModal({
      title: t('build:nextQuizModal.title'),
      selectLabel: t('build:nextQuizModal.select'),
      lockedSelectLabel: t('build:nextQuizModal.lockQuiz'),
      rootOnly: false,
      excludeQuizsetIds,
      onSelect: quiz => {
        logger.track('selectNextQuizset');
        selectedQuizsetId = quiz.id;
      },
      onPreview: () => logger.track('previewNextQuizset', {
        from: 'selectModal'
      })
    });
    return selectedQuizsetId;
  };
};